import { FC } from 'react';

const DiabetesFriendlyIcon: FC<{
  fill?: string;
  height?: number;
  width?: number;
}> = ({ fill = '#3C3F43', height = 16, width = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_42647_22688)">
        <path
          d="M0.666504 0.666992L15.3331 15.3337"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.74072 4.74121L3.43701 5.39306V10.6079L8 12.8893L11.2593 11.2597"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.8711 13.4756C4.7991 13.4756 4.74072 13.4172 4.74072 13.3452C4.74072 13.2732 4.7991 13.2148 4.8711 13.2148"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
        />
        <path
          d="M4.87109 13.4756C4.94309 13.4756 5.00147 13.4172 5.00147 13.3452C5.00147 13.2732 4.94309 13.2148 4.87109 13.2148"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
        />
        <path
          d="M2.91553 14.9424C2.84353 14.9424 2.78516 14.884 2.78516 14.812C2.78516 14.74 2.84353 14.6816 2.91553 14.6816"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
        />
        <path
          d="M2.91553 14.9424C2.98753 14.9424 3.0459 14.884 3.0459 14.812C3.0459 14.74 2.98753 14.6816 2.91553 14.6816"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
        />
        <path
          d="M0.959963 13.4756C0.887963 13.4756 0.82959 13.4172 0.82959 13.3452C0.82959 13.2732 0.887963 13.2148 0.959963 13.2148"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
        />
        <path
          d="M0.959961 13.4756C1.03196 13.4756 1.09033 13.4172 1.09033 13.3452C1.09033 13.2732 1.03196 13.2148 0.959961 13.2148"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
        />
        <path
          d="M8 8V12.8889"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.75977 3.73135L7.99983 3.11133L12.5628 5.39281L10.1056 6.62137"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.563 10.2818V5.39551"
          stroke={fill}
          stroke-width="1.3333"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_42647_22688">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DiabetesFriendlyIcon;
